import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  MatLegacyAutocompleteTrigger as MatAutocompleteTrigger,
  MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent,
} from '@angular/material/legacy-autocomplete';
import { Observable, Subject } from 'rxjs';
import { debounceTime, takeUntil, distinctUntilChanged, tap } from 'rxjs/operators';

// Services
import { RfqApiService } from '../../../shared/services/api/rfq/rfq-api.service';

@Component({
  selector: 'lum-rfq-list-dropdown',
  templateUrl: './rfq-list-dropdown.component.html',
  styleUrls: ['./rfq-list-dropdown.component.scss'],
})
export class RfqListDropdownComponent implements OnInit {
  @ViewChild('autocompleteInput')
  autocompleteInput :ElementRef<HTMLInputElement>;

  @ViewChild(MatAutocompleteTrigger)
  autocompleteTrigger :MatAutocompleteTrigger;

  @Input()
  label :string = '';

  @Input()
  displayValue :string = '';

  @Input()
  placeholder :string = '';

  @Input()
  type :string = 'text';

  @Input()
  rfqType :string = '';

  @Input()
  params :{ [param :string] :string | string[] } = {};

  @Output()
  selectOptionEvent = new EventEmitter<any>();

  rfqs :any = [];

  loading$ :Observable<boolean>;
  rfqs$ :Observable<any>;

  private searchUpdated$ = new Subject<string>();
  private onDestroy$ = new Subject();

  constructor(private rfqApiService :RfqApiService) {}

  ngOnInit() :void {
    this.getDataFromService();
    this.onSearchUpdate().subscribe();
    this.getRfqsFromObservable().subscribe();
  }

  onSearchKeywordChange(event :any) :void {
    this.searchUpdated$.next(event.target.value);
  }

  onSelectOption(event :MatAutocompleteSelectedEvent) :void {
    this.selectOptionEvent.emit({ rfq: event.option.value });
  }

  displayFn(option :any) :string {
    return option && option.sku ? `${option.product_name}[${option.sku}]` : '';
  }

  reset(isResetList :boolean = false) :void {
    this.autocompleteInput.nativeElement.value = '';
    this.autocompleteTrigger.closePanel();
    if (isResetList) {
      this.rfqs = [];
    }
  }

  private getDataFromService() :void {
    this.rfqs$ = this.rfqApiService.rfqs$;
    this.loading$ = this.rfqApiService.loading$;
  }

  private onSearchUpdate() :Observable<string> {
    return this.searchUpdated$.asObservable().pipe(
      debounceTime(500),
      distinctUntilChanged(),
      tap((keyword :string) => {
        this.rfqApiService.search({
          ...this.defaultParams(),
          sku: keyword,
        });
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private getRfqsFromObservable() :Observable<any> {
    return this.rfqs$.pipe(
      tap((rfqs :any) => {
        this.rfqs = rfqs;
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private defaultParams() :any {
    const params :any = {
      per_page: '15',
      offset: '0',
    };

    if (Object.keys(this.params).length > 0) {
      Object.entries(this.params).forEach(([key, value]) => {
        if (!(key in params)) {
          (params as any)[key] = value;
        }
      });
    }

    if (this.rfqType !== '') {
      params.rfqType = this.rfqType;
    }

    return params;
  }
}
